import axios from "axios"

export const NetsisApi = {
    async CustomerAccount(data){
        const response = await axios.post('/api/netsis/table/customeraccounts',data)
        return response
    },
    async CustomerAccountAction(data){
        const response = await axios.post('/api/netsis/table/customeraccountactions',data)
        return response
    },
    async CustomerAccountActionStats(data){
        const response = await axios.get(`/api/netsis/stats/customeraccountactions/${data}`)
        return response
    },
    async CustomerContact(data){
        const response = await axios.post('/api/netsis/createorupdate/customercontact',data)
        return response
    },
    async CanBeInstallmentWithoutApprove(){
        const response = await axios.get('/api/netsis/get/canbeinstallmentwithoutapprovedata')
        return response
    },
    async FaturaDetay(cariCode,documentNo){
        const response = await axios.get(`/api/netsis/faturadetayi/${cariCode}/${documentNo}`)
        return response
    }
}